// ============================================================================
// remote/inputKeys.ts — ОБЩИЕ данные ввода «Удалённого доступа» (SSoT/SRP).
// Карта спец-клавиш (Windows VK), VK для одиночного символа в комбинации
// (Ctrl+C и т.п.) и доступ к Keyboard Lock API. Служит ЕДИНЫМ источником и для
// LiveKit-пути (components/remote/useRemoteControl), и для контрактного вьюера
// (components/remote/useContractViewer) — без дублей карт клавиш.
// ============================================================================

/** Виртуальные коды клавиш (Windows VK) для спец-клавиш и модификаторов. */
export const KEY_SCANCODES: Record<string, number> = {
  Enter: 0x0d,
  Tab: 0x09,
  Backspace: 0x08,
  Escape: 0x1b,
  Delete: 0x2e,
  Insert: 0x2d,
  ArrowUp: 0x26,
  ArrowDown: 0x28,
  ArrowLeft: 0x25,
  ArrowRight: 0x27,
  ' ': 0x20,
  Home: 0x24,
  End: 0x23,
  PageUp: 0x21,
  PageDown: 0x22,
  Shift: 0x10,
  Control: 0x11,
  Alt: 0x12,
  Meta: 0x5b,
  CapsLock: 0x14,
  F1: 0x70, F2: 0x71, F3: 0x72, F4: 0x73, F5: 0x74, F6: 0x75,
  F7: 0x76, F8: 0x77, F9: 0x78, F10: 0x79, F11: 0x7a, F12: 0x7b,
};

/** Виртуальный код клавиши для одиночного символа в КОМБИНАЦИИ (Ctrl+C и т.п.).
 *  Возвращает 0, если символ не буква/цифра (комбинация не отправляется). */
export function charToVk(ch: string): number {
  if (ch.length !== 1) return 0;
  const code = ch.toUpperCase().charCodeAt(0);
  if (code >= 0x41 && code <= 0x5a) return code; // A–Z
  if (code >= 0x30 && code <= 0x39) return code; // 0–9
  return 0;
}

export interface KeyboardLockApi {
  lock?: (keys?: string[]) => Promise<void>;
  unlock?: () => void;
}

/** Keyboard Lock API (Chromium, только fullscreen). Feature-detect. */
export function keyboardLockApi(): KeyboardLockApi | undefined {
  return (navigator as Navigator & { keyboard?: KeyboardLockApi }).keyboard;
}
